export interface SearchCustomerResponseRow {
  Enabled: boolean
  CreateDate: string
  LastModifiedDate: string
  Username: string
  EmailAddress: string
  CompanyUUID: string
}
export interface CustomerInterface {
  CustEosID: string
  CustName: string
  CustNo: string
  OuName: string
  ShipAddr: string
  ShipToLoc: string
  ShipToPostalCode: string
  ShipToState: string
  AppId: string
}

export interface CustomerInterface {
  CustEosID: string
  CustName: string
  CustNo: string
  OuName: string
  ShipAddr: string
  ShipToLoc: string
  ShipToPostalCode: string
  ShipToState: string
}
export interface ecommerceInterface {
  AbcIndicator: string
  ActivationCode: string
  ActivationStatus: string
  Auth0Id: string
  CreationDate: string
  CustomerSegmentation: string
  EmailId: string
  EmailSentDate: string
  ModuleName: string
  Name: string
  SalesRegion: string
  User: string
}
export interface extractedDataInterface {
  CustEosID: string
  OuName: string
  AppId: string
}

export interface ChildComponentData {
  extractedDataPass: extractedDataInterface | null
  ecomTabData: ecommerceInterface | null
  isShow: boolean
  custNo: string
  custName: string | undefined
}
export interface conceptInterface {
  ModuleId: string
  ModuleName: string
  ModuleType: string
  ContractStartDate: string
  ContractEndDate: string
}
export type conceptsResponseTable = conceptInterface[]

export interface salesAgreementInterface {
  ContractId: string
  ContractName: string
  ContractType: string
  EndOfContract: string
  StartOfContract: string
}
export type salesAgreementsResponseTable = salesAgreementInterface[]

export interface conceptsResponse {
  Data: conceptInterface[]
  AbcIndicator: string
  BillToLoc: string
  BranchCode: string
  BranchID: string
  CreatedAt: string
  CustEosID: string
  CustName: string
  CustNo: string
  CustStatus: string
  CustomerGroup: string
  CustomerGroupDesc: string
  Email: string
  KnownAs: string
  OuName: string
  PaymentMethod: string
  Phone: string
  PrimaryFlag: string
  SalesRep: any
  ShipAddr: string
  ShipToCity: string
  ShipToCoordinates: string
  ShipToCountry: string
  ShipToID: string
  ShipToLoc: string
  ShipToPostalCode: string
  ShipToProvince: string
  ShipToState: string
  ShipToStreet: string
  Teccom: string
  TsmBlocked: string
  UpdatedAt: string
  Vat: string
  VolumeGroup: string
  VolumeGroupDesc: string
  VolumeGroupType: string
  VolumeGroupTypeDesc: string
}
export interface CustomerInterface {
  AbcIndicator: string
  BillToLoc: string
  BranchCode: string
  BranchID: string
  CreatedAt: string
  CustEosID: string
  CustName: string
  CustNo: string
  CustStatus: string
  CustomerGroup: string
  CustomerGroupDesc: string
  Email: string
  KnownAs: string
  OuName: string
  PaymentMethod: string
  Phone: string
  PrimaryFlag: string
  SalesRep: any
  ShipAddr: string
  ShipToCity: string
  ShipToCoordinates: string
  ShipToCountry: string
  ShipToID: string
  ShipToLoc: string
  ShipToPostalCode: string
  ShipToProvince: string
  ShipToState: string
  ShipToStreet: string
  Teccom: string
  TsmBlocked: string
  UpdatedAt: string
  Vat: string
  VolumeGroup: string
  VolumeGroupDesc: string
  VolumeGroupType: string
  VolumeGroupTypeDesc: string
}

export interface ResendLinkStatusResponse {
  Data: {
    Email: string
    Status: string
  }
}

export interface CustomersBySearchQueryProps {
  setAPISearchQuery: (newSearchQuery: string) => void
  handleReload?: () => void
  applyFiltersToQuery?: () => Promise<void>
}

export interface CustomerSearchQuery {
  Customer: CustomerInterface
}

export interface FilterAndSearchQueryObjectType {
  Query: string
  OuName: string
  AppId: string
  ModuleID: string
  ActivationStatus: string
  EcommerceStatus: string
}

export interface UseSearchByQueryOfferPackage {
  getSearchComponent: () => JSX.Element
  apiSearchQuery: string
}
export interface UseSearchByQuery {
  getSearchComponent: () => JSX.Element
  apiSearchQuery: string
  updateListBYDropDownFilters: () => Promise<void>
}
export enum FilersConstants {
  DEFAULT_QUERY = '',
  NONE = 'None'
}
export interface IFiltersParams {
  Query: string
  EcommerceStatus: string
  ModuleID: string
  ActivationStatus: string
}

export function getTableQuery(customersFoundByQuery: CustomerInterface[], customerSearchQueryInList: any) {
  if (customersFoundByQuery?.length) {
    customerSearchQueryInList.groupStart()
    customersFoundByQuery.forEach((customer: CustomerInterface, index: number) => {
      customerSearchQueryInList.equals((c: { Customer: { CustEosID: string } }) => c.Customer.CustEosID, customer.CustEosID)
      if (index < customersFoundByQuery.length - 1) customerSearchQueryInList.or()
    })
    customerSearchQueryInList.groupEnd()
  } else {
    customerSearchQueryInList.equals((c: { Customer: { CustEosID: string } }) => c.Customer.CustEosID, 'xxxxxxxxxxxxxxxxxxxx')
  }
  return customerSearchQueryInList.toString()
}

const appendQueryCondition = (queryString: string, condition: string): string => {
  return queryString ? `${queryString},${condition}` : condition
}
export async function apiFilters(filtersParams: IFiltersParams): Promise<string | void> {
  const { Query, EcommerceStatus, ModuleID, ActivationStatus } = filtersParams
  let queryString = ''
  if (Query) {
    queryString += getTopBarSearchQuery(Query)
  }
  if (EcommerceStatus) {
    queryString =
      EcommerceStatus !== FilersConstants.NONE ? appendQueryCondition(queryString, `SignUp.EcommStatus|=|${EcommerceStatus}`) : queryString
  }

  if (ModuleID) {
    queryString =
      ModuleID !== FilersConstants.NONE ? appendQueryCondition(queryString, `SubscriptionData.ModuleID|=|${ModuleID}`) : queryString
  }

  if (ActivationStatus) {
    queryString =
      ActivationStatus !== FilersConstants.NONE
        ? appendQueryCondition(queryString, `SignUp.CompletionStatus|=|${ActivationStatus}`)
        : queryString
  }
  return queryString
}

export function getTopBarSearchQuery(Query: string): string {
  return `(Customer.CustEosID|ILIKE|%${Query}%;Customer.CustName|ILIKE|%${Query}%;Customer.ShipToLoc|=|${Query};Customer.CustNo|=|${Query}
  )`
}

// email panding list

export interface CustomerEmailInterface {
  AttemptCount: number
  CreatedAt: Date
  CustomerEOSID: string
  EmailBody: string
  EmailFrom: string
  EmailSubject: string
  EmailTo: string
  ErrorMessage: string
  ErrorType: string
  LastAttempt: Date
  PendingEmailUUID: string
  ReceiverEmail: string
  TemplateName: string
  AppId: string
}

export interface CustomerPendingEmailSearchQuery {
  PendingLogsOutput: CustomerEmailInterface
}

export interface PendingLogSearchQuery {
  groupStart: () => void
  groupEnd: () => void
  equals: (field: (c: any) => any, value: any) => PendingLogSearchQuery
  and: () => PendingLogSearchQuery
  or: () => PendingLogSearchQuery
  toString: () => string
}

export interface ApiResponses<T> {
  Data: T
}

export enum SearchQueryConstants {
  MIN_QUERY_LENGTH = 3
}

export function getPendingEmailTableQuery(
  pendingLogFoundByQuery: CustomerEmailInterface[],
  pendingLogSearchQueryInList: PendingLogSearchQuery
) {
  if (pendingLogFoundByQuery?.length) {
    pendingLogSearchQueryInList.groupStart()
    pendingLogFoundByQuery.forEach((email: CustomerEmailInterface, index: number) => {
      pendingLogSearchQueryInList
        .equals((c: { PendingLogsOutput: { CustomerEOSID: string } }) => c.PendingLogsOutput.CustomerEOSID, email.CustomerEOSID)
        .and()
        .equals((c: { PendingLogsOutput: { ReceiverEmail: string } }) => c.PendingLogsOutput.ReceiverEmail, email.ReceiverEmail)
      if (index < pendingLogFoundByQuery.length - 1) pendingLogSearchQueryInList.or()
    })
    pendingLogSearchQueryInList.groupEnd()
  } else {
    pendingLogSearchQueryInList.equals(
      (c: { PendingLogsOutput: { CustomerEOSID: string } }) => c.PendingLogsOutput.CustomerEOSID,
      'xxxxxxxxxxxxxxxxxxxx'
    )
  }
  return pendingLogSearchQueryInList.toString()
}

export function getPendingEmailTableQueryByTemplateName(
  pendingLogFoundByQuery: CustomerEmailInterface[],
  pendingLogSearchQueryInList: PendingLogSearchQuery
) {
  if (pendingLogFoundByQuery?.length) {
    pendingLogSearchQueryInList.groupStart()
    pendingLogFoundByQuery.forEach((email: CustomerEmailInterface, index: number) => {
      pendingLogSearchQueryInList
        .equals((c: { PendingLogsOutput: { CustomerEOSID: string } }) => c.PendingLogsOutput.CustomerEOSID, email.CustomerEOSID)
        .and()
        .equals((c: { PendingLogsOutput: { TemplateName: string } }) => c.PendingLogsOutput.TemplateName, email.TemplateName)
      if (index < pendingLogFoundByQuery.length - 1) pendingLogSearchQueryInList.or()
    })
    pendingLogSearchQueryInList.groupEnd()
  } else {
    pendingLogSearchQueryInList.equals(
      (c: { PendingLogsOutput: { CustomerEOSID: string } }) => c.PendingLogsOutput.CustomerEOSID,
      'xxxxxxxxxxxxxxxxxxxx'
    )
  }
  return pendingLogSearchQueryInList.toString()
}
